query currentUser {
  currentUser{
    id
    email
    first
    last
    wantsEmailNotifications
    teams {
      id
      name
    }
    teachers {
      id
      forwardingNumber
      formattedForwardingNumber
      insertedAt
      team {
        id
        name
      }
      teacherPhoneNumbers {
        id
        number
        formattedNumber
      }
    }
  }
}
